var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewscence6(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 675,
    height: 675,
    viewBox: "0 0 675 675",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_134_956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M675 0H0V675H675V0Z",
    fill: "#8B40FD"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_134_956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M248 964C421.97 964 563 822.97 563 649C563 475.03 421.97 334 248 334C74.0303 334 -67 475.03 -67 649C-67 822.97 74.0303 964 248 964Z",
    fill: "#40FFCF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609 476C782.97 476 924 334.97 924 161C924 -12.9697 782.97 -154 609 -154C435.03 -154 294 -12.9697 294 161C294 334.97 435.03 476 609 476Z",
    fill: "#8B40FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441 706C614.97 706 756 564.97 756 391C756 217.03 614.97 76 441 76C267.03 76 126 217.03 126 391C126 564.97 267.03 706 441 706Z",
    fill: "#40FFCF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441 467C614.97 467 756 325.97 756 152C756 -21.9697 614.97 -163 441 -163C267.03 -163 126 -21.9697 126 152C126 325.97 267.03 467 441 467Z",
    fill: "#40FFCF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141 714C314.97 714 456 572.97 456 399C456 225.03 314.97 84 141 84C-32.9697 84 -174 225.03 -174 399C-174 572.97 -32.9697 714 141 714Z",
    fill: "#8B40FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69 478C242.97 478 384 336.97 384 163C384 -10.9697 242.97 -152 69 -152C-104.97 -152 -246 -10.9697 -246 163C-246 336.97 -104.97 478 69 478Z",
    fill: "#40FFCF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_134_956",
    x: -530,
    y: -447,
    width: 1738,
    height: 1695,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 142,
    result: "effect1_foregroundBlur_134_956"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_134_956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 675,
    height: 675,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewscence6);
export default __webpack_public_path__ + "static/media/newscence6.3aca37af7018814701988334b40c00ba.svg";
export { ForwardRef as ReactComponent };